import { useState } from "react";
import { Download, BarChart3, Users as UsersIcon, DollarSign, Activity } from "lucide-react";
import AdminShell, { Panel, Btn } from "@/components/admin/AdminShell";
import KpiCard from "@/components/admin/KpiCard";
import DataTable from "@/components/admin/DataTable";
import { apiBaseUrl } from "@/lib/api";

const REPORT_TYPES = [
  { id: "users", label: "Trading Volume", endpoint: "/api/admin/reports/otc-trades.csv" },
  { id: "user-activity", label: "User Activity", endpoint: "/api/admin/reports/users.csv" },
  { id: "revenue", label: "Revenue", endpoint: "/api/admin/reports/otc-trades.csv" },
  { id: "compliance", label: "Compliance", endpoint: "/api/admin/reports/login-audit.csv" },
  { id: "audit-trail", label: "Audit Trail", endpoint: "/api/admin/reports/login-audit.csv" },
];
const DATE_RANGES = ["Today", "Last 7 days", "Last 30 days", "MTD", "YTD"];

const fmt = (v) => v?.toLocaleString("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }) || "—";

export default function ReportsAnalytics() {
  const [reportType, setReportType] = useState(REPORT_TYPES[0].id);
  const [range, setRange] = useState("Last 30 days");
  const recent = [
    { name: "Trading Volume — Last 30 days", generated_at: "2026-04-26 14:30", size: "2.3 MB", type: "Trading Volume", endpoint: "/api/admin/reports/otc-trades.csv" },
    { name: "User Activity — MTD", generated_at: "2026-04-25 09:12", size: "950 KB", type: "User Activity", endpoint: "/api/admin/reports/users.csv" },
    { name: "Revenue — YTD", generated_at: "2026-04-22 18:00", size: "4.1 MB", type: "Revenue", endpoint: "/api/admin/reports/otc-trades.csv" },
    { name: "Login Audit — Last 7 days", generated_at: "2026-04-20 11:45", size: "780 KB", type: "Audit Trail", endpoint: "/api/admin/reports/login-audit.csv" },
  ];

  return (
    <AdminShell title="Reports & Analytics">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-5">
        <KpiCard label="Total Trading Volume" value={fmt(245_000_000)} delta="+18%" icon={BarChart3} variant="yellow" />
        <KpiCard label="Total Users" value="1,234" delta="+45" icon={UsersIcon} variant="green" />
        <KpiCard label="Revenue MTD" value={fmt(2_500_000)} delta="+12%" icon={DollarSign} variant="blue" />
        <KpiCard label="Active Traders" value="487" delta="+8.5%" icon={Activity} variant="purple" />
      </div>

      <Panel className="p-5 mb-5">
        <h3 className="text-[14px] font-bold mb-4">Generate Report</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <label>
            <span className="block text-[10px] uppercase tracking-wider text-[#8892A8] mb-1.5">Report Type</span>
            <select value={reportType} onChange={(e) => setReportType(e.target.value)} className="w-full h-[40px] px-3 bg-[#0A0F1F] border border-[#1E2845] rounded-[8px] text-[13px]" data-testid="report-type">
              {REPORT_TYPES.map((r) => <option key={r.id} value={r.id}>{r.label}</option>)}
            </select>
          </label>
          <label>
            <span className="block text-[10px] uppercase tracking-wider text-[#8892A8] mb-1.5">Date Range</span>
            <select value={range} onChange={(e) => setRange(e.target.value)} className="w-full h-[40px] px-3 bg-[#0A0F1F] border border-[#1E2845] rounded-[8px] text-[13px]" data-testid="report-range">
              {DATE_RANGES.map((r) => <option key={r}>{r}</option>)}
            </select>
          </label>
          <div className="flex items-end">
            <a href={`${apiBaseUrl()}${REPORT_TYPES.find(r => r.id === reportType).endpoint}`} target="_blank" rel="noreferrer" className="inline-flex">
              <Btn data-testid="generate-report"><Download size={14} /> Generate</Btn>
            </a>
          </div>
        </div>
      </Panel>

      <Panel>
        <div className="p-4 border-b border-[#1E2845]"><h3 className="text-[14px] font-bold">Recent Reports</h3></div>
        <DataTable
          testid="recent-reports"
          columns={[
            { key: "name", header: "Report", render: (r) => <span className="font-semibold">{r.name}</span> },
            { key: "type", header: "Type" },
            { key: "generated_at", header: "Generated" },
            { key: "size", header: "Size", align: "right" },
            { key: "actions", header: "", align: "right", render: (r) => <a href={`${apiBaseUrl()}${r.endpoint}`} target="_blank" rel="noreferrer" className="text-[#F0B83A] text-[11px] hover:underline inline-flex items-center gap-1"><Download size={11} /> Download</a> },
          ]}
          rows={recent}
        />
      </Panel>
    </AdminShell>
  );
}
